import { sortHomeWidgets } from '../../../components/widgets/homeWidgets/helpers';
import type { HomeWidgetsPriority } from '../../../components/widgets/homeWidgets/types';
import { FREE_SPIN_PROVIDERS, HOME_WIDGET_WIDGET_TYPE_MAPPING } from '../constants';
import type { SortHomeWidgetType, Widget } from '../types';

export const sortWidgets = (widgets: Widget[], homeWidgetsOrder?: HomeWidgetsPriority): Widget[] => {
  const widgetsMap = new Map<string, Widget>();
  const sortTypedWidgets: SortHomeWidgetType[] = [];

  widgets.forEach((widget) => {
    widgetsMap.set(widget.id, widget);
    const type = HOME_WIDGET_WIDGET_TYPE_MAPPING[widget.type];
    if (type) {
      sortTypedWidgets.push({
        id: widget.id,
        type,
        weight: widget.data.weight,
      });
    }
  });

  const sortedHomeWidgets = sortHomeWidgets(sortTypedWidgets, homeWidgetsOrder);

  return sortedHomeWidgets.flatMap((widget) => widgetsMap.get(widget.id) ?? []);
};

export const isFreeSpinMiniGame = (provider: string) => {
  return [FREE_SPIN_PROVIDERS.BAROULETTA, FREE_SPIN_PROVIDERS.MINIGAMES].includes(provider);
};
